import React from "react";
import { NavLink } from "react-router-dom";

type AccountLockItem = {
	path: string;
	translation: string;
};

export default function AccountSettingsSideMenuItem(props: AccountLockItem) {
	const { path, translation } = props;

	return (
		<li className="nav--tertiary__item">
			<NavLink
				to={path}
				className="nav--tertiary__link"
				activeClassName="is-active"
				isActive={(_, location) => location.pathname.includes(path)}
			>
				<span className="nav--tertiary__title">{translation}</span>
			</NavLink>
		</li>
	);
}
